var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "samc-dropdown",
    {
      ref: "dropdown",
      attrs: {
        "enable-clear": "",
        "enable-search": "",
        value: _vm.val,
        placeholder: _vm.loaded ? _vm.placeholder : "Loading...",
        disabled: !_vm.loaded,
      },
      on: {
        searchChanged: _vm.onSearchChange,
        valueChanged: _vm.onValueChange,
        selectOption: _vm.onOptionSelected,
      },
    },
    [
      _vm.flattenedItems.length === 0
        ? _c("div", { staticClass: "no-mappings-found" }, [
            _vm._v("\n    No Mappings Found\n  "),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.flattenedItems, function (item) {
        return _c(
          "samc-option",
          {
            key: item.id,
            attrs: {
              value: item.id,
              text: item.name,
              "has-children": item.isFolder,
              level: item.isFolder ? 0 : 1,
            },
          },
          [_vm._v("\n    " + _vm._s(item.name) + "\n  ")]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }